import { styled, Typography } from "@mui/material";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { grey } from "@mui/material/colors";
import * as React from "react";
import { Property } from "csstype";

export const KahunPrimaryTypography = styled(
  ({
    ...props
  }: {
    children?: any;
    display?: Property.Display;
    className?: string;
  }) => <Typography variant={"body1"} {...props} />,
)({
  color: KahunColorMap.Primary,
});
export const KahunSecondaryTypography = styled(
  ({ children, ...props }: { children?: any }) => (
    <Typography variant={"body2"} {...props} />
  ),
)({
  color: grey[500],
});

export const KahunAccentTypography = styled(({ ...props }) => (
  <Typography variant={"caption"} {...props} />
))({
  color: KahunColorMap.Accent,
  fontWeight: "bolder",
});
